import { DataBean } from "../DataBean";

export class ReleaseProdOrderExternal extends DataBean {



    public async releaseProductionOrderFromExternalFactory(idProductionOrder: any, productionOrderDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_releaseProductionOrderFromExternalFactory_Number_java.util.Date", [idProductionOrder, productionOrderDate]);
    }

}